// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.test.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  defaultTheme: 'nfl',
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'test',
  stageBucket: 'lsb-test-clubs-stage-zone',
  domain: 'https://lsb-compliance-test.dna.nfl.net/',
  region: 'us-east-1',
  auth: {
    hostname: 'lsb-test-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://lsb-compliance-test.dna.nfl.net/login'],
    response_type: 'code',
    client_id: '131b2s6184dn49idfntn509m92',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_IpVqnH4eH',
    identity_pool_id: 'us-east-1:53c27c58-be27-42e6-8efc-3b5b28f55551',
    domain: 'lsb-compliance-test.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://lsb-compliance-test.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
};
